<template>
  <div>
    <vxe-grid
      ref="xTable"
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :columns="tablePoint"
      :toolbar-config="tableToolbar"
      row-key
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-warning">
            <span class="side-frame-text">线路节点信息</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="fromLoad('add')"
              :disabled="disabled"
              >添加节点
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="delSelectRow()"
              :disabled="disabled"
              >删除节点
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-link
            class="mr-2"
            type="primary"
            @click="fromLoad('edit', row)"
            :disabled="disabled"
            >编辑
          </el-link>
          <el-link type="danger" @click="delRow(row)" :disabled="disabled"
            >删除</el-link
          >
        </div>
      </template>
      <!-- <template v-slot:status="{ row }">
        {{ row.linePointStatus == 'Y' ? '有效' : '无效' }}
      </template> -->
      <template v-slot:type="{ row }">
        {{ row.linePointType == 'R' ? '收获方' : '发货方' }}
      </template>
    </vxe-grid>

    <point-edit
      ref="pointEdit"
      :params="params"
      @addRowSave="addRowSave"
      @editRowSave="editRowSave"
    />
  </div>
</template>
<script>
import tablePoint from './table-point'
export default {
  props: {
    code: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PointEdit: () => import('./line-point-edit.vue'),
  },
  data() {
    return {
      params: {},
      formData: {},
      tablePoint: tablePoint(),
      tableHeight: 360,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
    }
  },
  methods: {
    reset() {
      this.formData = {}
      this.tableData = []
    },
    fromLoad(ref, row = {}) {
      if (ref === 'edit') {
        // 获取当前记录在记录集中的唯一索引
        let index = this.$refs.xTable.getRowIndex(row)
        this.$refs.pointEdit.load(ref, { ...row, index: index })
        return
      }
      this.$refs.pointEdit.load(ref, { ...row })
    },
    addRowSave(rowData) {
      this.tableData.push(rowData)
    },
    editRowSave(rowData) {
      for (let i = 0; i < this.tableData.length; i++) {
        if (i === rowData.index) {
          this.$set(this.tableData, i, rowData)
        }
      }
    },
    delSelectRow() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords()
      if (selectRecords.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要删除的数据',
          type: 'warning',
        })
        return
      }
      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$refs.xTable.removeCheckboxRow()
          selectRecords.forEach((item) => {
            let _XID = item._XID
            this.tableData.forEach((row, index) => {
              if (row._XID === _XID) {
                this.tableData.splice(index, 1)
              }
            })
          })
        }
      })
    },
    delRow(row) {
      this.$confirm('您确定要删除该数据吗?').then((type) => {
        if (type === 'confirm') {
            let index = this.$refs.xTable.getRowIndex(row)
            this.tableData.splice(index, 1)
        }
      })
    },
    getLinePointData() {
      if (this.tableData.length < 1) {
        this.$message.error('线路节点信息未填写，请检查')
        return
      }
      this.formData.pointList = this.tableData
      return this.formData
    },
  },
}
</script>
